export const DIVIDER_STYLE = { margin: '8px 0' };
